<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  @import "./style/global";
  body, h1, h2, h3, h4, h5, p {
    margin: 0;
  }
  * {
    box-sizing: border-box;
  }

  .hidenText {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  /*去除mapbox图标水印*/
  a.mapboxgl-ctrl-logo,.mapboxgl-ctrl.mapboxgl-ctrl-attrib.mapboxgl-compact,.mapboxgl-ctrl-bottom-right .mapboxgl-ctrl.mapboxgl-ctrl-attrib{
    display: none!important;
  }
  .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    background-color: $yellow!important;
    border-color: $yellow!important;
    box-shadow: none!important;
  }
</style>
